import React from 'react';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AuthFooterProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Trust strip for authentication pages (Login, Activate, Reset Password):
 * chrome surface, inset pill with a success dot, lock icon and the secure-connection caption.
 */
const AuthFooter: React.FC<AuthFooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();
  if (children) {
    return <footer className={`w-full ${className}`}>{children}</footer>;
  }

  return (
    <footer
      className={`relative flex h-full min-h-0 w-full flex-col items-center justify-center border-t border-edge-subtle bg-chrome px-3 py-2 backdrop-blur-md ${className}`}
    >
      <div className="inline-flex items-center gap-2 rounded-full border border-edge-subtle bg-inset px-3 py-1.5 @bp-sm:px-4">
        <span className="size-1.5 shrink-0 rounded-full bg-success" aria-hidden />
        <Lock className="size-3 shrink-0 text-tertiary" aria-hidden />
        <span className="whitespace-nowrap font-ui text-small font-medium text-secondary">
          {t('authFooter.secureConnectionEstablished')}
        </span>
      </div>
    </footer>
  );
};

export default AuthFooter;
